const literary = [
  {
    title: "Debate(Hindi/English)",
    date: "29/09/2022",
    timing: "10:30 AM - 12:00 PM",
    venue: "Seminar Hall",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "Participants- Single Participation.",
      "1.	This will be an individual contest.",
      "2.	Time limit: 3 min for each side of the person and 1min for debate on contradictory points.",
      "3.	The topics would be declared in advance (list attached)",
      "4.	Participants will have choices to speak for and against the motion.",
      "5.	Participants should speak relevant points related to the topic.",
      "6.	Each speaker will present his/her speech in Hindi/ English.",
      "7.	Warning bell will be rung after 2 ½ min for each of the participant and final bell after 3 min.",
      "8.	Exceeding the prescribed time will result negative marks.",
      "Evaluation Parameters:",
      "The speaker will be judged on the following criteria, and will be awarded marks accordingly.",
      "Evaluation Basis:	Marking Scheme (Marks)",
      "	1.Interpretation of the motion	10",
      "	2.Logical presentation of argument	10",
      "	3.Evidences and examples	10",
      "	4.Audibility and loudness	10",
      "	5.Rebuttal of interjection	10",
      "Total of 50 Marks",
    ],
  },
  {
    title: "Creative Writing",
    date: "29/09/2022",
    timing: "11:00 AM - 02:30 PM",
    venue: "2F-32",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "Participant- Single Participant",
      "1.In this event participants have to write an essay on the given topic. Topic will be common to all participants and will be given on the spot. (200-250 words)",
      "2.Obey the rules of grammar, usage and punctuation.",
      "3.Make your language concrete, not abstract; specific, not general.",
      "4.Maintain a consistent style and tone.",
      "5.Use adjectives and adverbs with restraint.",
      "6.Use of vulgar language is not permissible.",
      "7.Language either Hindi or English but not a mixed one.",
      "8.Participants should carry their own pen/pencil.",
    ],
  },
  {
    title: "Spell Bee ",
    date: "29/09/2022",
    timing: "11:30 AM - 02:30 PM",
    venue: "2F-27",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "Participants- Individual ",
      "Rules:",
      "1.Preliminary / Elimination round is a qualifying for the event. Those participants who fail to appear for the preliminary round shall not be considered for the finals.",
      "2.Every entry should contain the following details: Name, Class, College roll no., Address, Phone and Email.",
      "3.The registrations are to be done on-line.",
      "4.The maximum time for SPELL A WORD is 30 seconds.",
      "5.The rules and regulations for the preliminary and final round shall remain the same.",
      "6.The organizing Committee reserves the right to change the venue, time and rules, if desired.",
    ],
  },
  {
    title: "Check your knowledge (General quiz) ",
    date: "29/09/2022",
    timing: "12:00 PM - 02:00 PM",
    venue: "2F-04",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "Participants- 3 Participant ",
      "Rules:",
      "1 .Participants are requested to register online for the quiz on the college website.",
      "2 .Participants are requested to register in form of team of three members.",
      "3 .Final selection of the team would be done on the basis of an on the spot written test.",
      "4 .The team would be selected on the basis of criteria of minimum time used and maximum questions answered.",
      "5 .Finalized four teams would take part in the main quiz.",
      "6 .The quiz comprises of 5 rounds.",
      "7 .First round comprises of questions related to Current affairs.",
      "8 .Second round comprises of questions related to Politics.",
      "9 .Third round comprises of questions based on Geographical conditions.",
      "10.Fourth round comprises of questions based on Sports.",
      "11.Fifth round comprises of questions based on Miscellaneous questions .",
      "12.Each team would be allotted 45 seconds for answering the questions.",
      "13.Each questions answered correctly would be awarded 5 points for each wrong answer 2 points would be deducted from the team answering.",
      "14.The quiz would be buzzer based quiz the team pressing the buzzer the first would be given the first opportunity to answer the question.",
      "15.If the team is unable to answer the question correctly the question would be passed to the other three teams.",
      "16.If the team is unable to answer the question within the time limit the would be negatively marked i.e. (-2 points).",
      "17.For the team answering the passed question correctly they would be awarded (+2 points).",
      "18.For wrongly answered passed questions 1 point would be deducted from the answering team.",
    ],
  },
  {
    title: "Make it Funny",
    date: "29/09/2022",
    timing: "12:30 AM - 02:00 PM",
    venue: "2F-33",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "Participants- Single Participant",
      "1.In this event a popular or well-known story will be given as a subject. Participants have to insert some fun in given story. (150-200 words).",
      "2.Maintain a consistent style and tone.",
      "3.Use adjectives and adverbs with restraint.",
      "4.Use of vulgar language is not permissible.",
      "5.Language either Hindi or English but not a mixed one.",
      "6.Participants should carry their own pen/pencil.",
    ],
  },
  {
    title: "Business proposal ",
    date: "29/09/2022",
    timing: "01:00 PM - 03:00 PM",
    venue: "Seminar Hall",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "Participants- Individual or team of 3 members.",
      "Objective:",
      "A business plan is a written description of your business's future, a document that tells what you plan to do and how you plan to do it.",
      "The objective of the Annual Business Plan Competition is to encourage student entrepreneurs and support the growth of jobs.",
      "Rules:",
      "Entry should be individual or comprise of a team of max 3 members",
      "1.	Each team can submit only one Business Plan on ppt and submit the report in hard copy.",
      "2.	Max. Time limit for presentation: 10 mins.",
      "3.	Participation requires submission of a report made on A4 size sheets of max. 4 pages and duly typed along with a presentation to be produced in front of the panel of the judges.",
      "4. Hard Copy of the Report will be prepared as per the attached template.",
      "5. Plan to be prepared for implementation, keeping in view the following parameters:",
      "     a.Macro and Micro environment analysis of the business selected",
      "    b.Market feasibility study - market potential, demand-supply analysis.",
      "    c.Developing marketing strategy",
      "       d.Competitor analysis",
      "   e.Estimated cost of the project and its financing",
      "   f .Technical and financial viability of the project",
      "6. There will a query round of max.10 Minutes after the presentation.",
      "Evaluation Parameters:	",
      "Evaluation Basis:	Marking Scheme (Marks)",
      "	1.Concept/Premise	10",
      "	2.Presentation	10",
      "	3.Commercial Potential	10",
      "	4.Social Impact	10",
      "	5.Challenge Evaluation	10",
      "Total of 50 Marks",
      "Tie Rule: If there is a tie between two teams then a question of any current business condition raised by judges, can be evaluated for winner.",
    ],
  },
  {
    title: "Poetry",
    date: "29/09/2022",
    timing: "02:00 PM - 04:00 PM",
    venue: "Auditorium",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "Participant- Single Participant",
      "1.In this event participants have to write a  poem. Individual and separate topic will be given to all on random basis. (16-20 lines)",
      "2.Maintain a consistent style and tone.",
      "3.Use of vulgar language is not permissible.",
      "4.Language can be either Hindi or English but not a mixed one.",
      "5.Participants should carry their own pen/pencil.",
    ],
  },
  {
    title: "AD MAD SHOW",
    date: "29/09/2022",
    timing: "03:00 PM - 05:00 PM",
    venue: "Seminar Hall",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "Participants- Individual to maximum 3 ",
      "Objective:",
      "Providing an opportunity to the students to present their creativity and communication skills.",
      "Advertising is the best way to communicate to the customers. Advertising helps to inform the customers about the brands available in the market and the variety of products useful to them.",
      "Rules:",
      "1 Participants- No of students per team: Individual to max 3 participants",
      "2.  Max. Time limit :	3 mins for presentation",
      "3.	Competition will have 2 rounds:",
      "Round 1: Each team will have to prepare their own advertisement based on their own creativity. (Maximum of 4 teams will be shortlisted for round 2)",
      "Round 2: The shortlisted teams will be given a product for preparing an advertisement within 30 min. Any material if required to be brought by the participants themselves.",
      "4.	The caution should be taken to refrain from displaying obscenity, violence, prejudice, defamation, ethical practices etc.",
      "5.	Decision of the judge's will be final and binding.",
      "Evaluation basis	MarkingScheme (marks).",
      "-Creativity	10",
      "-Adherence to the topic	10",
      "-Message Conveyed	10",
      "-On-stage presentation	10",
      "-Coordination and Over all appeal	10",
      "-The act should not contain any social or vulgar language.",
    ],
  },
  {
    title: "Wordsworth",
    date: "30/09/2022",
    timing: "10:30 AM - 12:00 PM",
    venue: "2F-32",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "1.In this event, pair of alphabets will be given to participants. The task is to write the maximum words possible having the pair of alphabet in the beginning, or in the middle or at the last of word.",
      "2.Obey the rules of grammar, usage and punctuation.",
      "3.Make your language concrete, not abstract; specific, not general.",
      "4.Maintain a consistent style and tone.",
      "5.Use adjectives and adverbs with restraint.",
      "6.Use of vulgar language is not permissible.",
      "7.Participants should carry their own pen/pencil.",
    ],
  },
  {
    title: "National Youth Parliament debate(Hindi/English)",
    date: "30/09/2022",
    timing: "11:00 AM - 02:30 PM",
    venue: "Auditorium",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "Participant- Team Participation with 3 to 6 members in a team.",
      "Minimum- 3 members",
      "Maximum- 5 members",
      "1 .English/Hindi should be the language for communication.",
      "2 .Use of vulgar language/words is not permissible.",
      "3 .There can be round 2nd  if the teams are more than 4.",
      "4 .Topic of debate as well as speakers in favor and against to be decided on the basis of lottery.",
      "5 .Time for Total activity is 55 mins.",
      "6 .Topic to be given on the spot and team will get 5 min to discuss with the team.",
      "7 .Team have to provide the issues in the topic, solutions in the topic through any bill or policy.",
      "8 .They should give imaginary or fictitious names to their parties and personalities. They should not give any impression that they have any leanings or bias for or against any political party or philosophy. ",
      "9 .The members should not say or do anything on the floor of the House that is not warranted by rules of procedures or by the ruling or precedence or by the accepted and established customs and conventions of the House.",
      "10.Members should not sit with their backs to the Chair. When a member wants to speak he should raise hands to attract the attention of the Chair. No member should speak unless he or she has ‘Caught’ the eye of the Speaker and has been permitted by the Chair by name or by a sign, to speak. ",
      "11.Every member should resume his seat as the Speaker rises to speak or calls out “order-order” and also when any other member is in possession of the floor. Two or more members should not keep standing at the same time. ",
      "12.No member should rise or leave the House when the Speaker is addressing the House. “The Speaker is always to be heard in silence”. ",
      "13.The duration of sitting of NYP should not exceed 55 minutes. Out of this, nearly 20 minutes may be devoted to Questions and the remaining time be utilized for discussion on topic.",
    ],
  },
  {
    title: "Connect the Objects",
    date: "30/09/2022",
    timing: "11:30 AM - 01:30 PM",
    venue: "2F-27",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "Participants- Single Participant",
      "1.Images of different objects will be given.",
      "2.Participants have to write a paragraph.",
      "3.Paragraph should contain features of each picture.",
      "4.Obey the rules of grammar, usage and punctuation.",
      "5.Make your language concrete, not abstract, specific, not general.",
      "6.Maintain a consistent style and tone.",
      "7.Use of vulgar language is not permissible.",
      "8.Language either English or Hindi but not a mixed one.",
      "9.Participants should carry their own pen/pencil.",
    ],
  },
  {
    title: "Dumb charades on Books ",
    date: "30/09/2022",
    timing: "11:30 AM - 01:30 PM",
    venue: "2F-27",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "Participants- Team of 4",
      "Rules:",
      "1.Team can comprise of 4 students.",
      "2.One from the team will be given a title of a book to enact.",
      "3.The other Participant will guess the name within the stipulated 1 minute.",
      "4.There can be 4 rounds.",
      "5.All the participants will be given a turn to enact.",
      "6.Participants cannot use sign language depicting alphabets.",
      "7.There will be scoring of 10 marks for every round.",
      "8.If there is a tie, then another round will be done to decide the winner.  ",
    ],
  },
  {
    title: "How positive you can",
    date: "30/09/2022",
    timing: "01:00 PM - 03:00 PM",
    venue: "2F-04",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "Participants- Single Participant",
      "1.In this event a negative will be displayed on projector for a duration of 15 minutes, during this time period participants have to write a positive aspect from the given image. (50-100 words)",
      "2.Obey the rules of grammar, usage and punctuation.",
      "3.Make your language concrete, not abstract; specific, not general.",
      "4.Maintain a consistent style and tone.",
      "5.Use adjectives and adverbs with restraint.",
      "6.Use of vulgar language is not permissible.",
      "7.Language either Hindi or English but not a mixed one.",
      "8.Participants should carry their own pen/pencil.",
    ],
  },
  {
    title: "Slogan Writing",
    date: "30/09/2022",
    timing: "02:00 PM - 04:00 PM",
    venue: "2F-32",
    bgColor: "blue",
    tag: "red",
    linkUrl:
      "https://medium.com/@popflorin1705/javascript-coding-challenge-1-6d9c712963d2",
    linkText: "Read Rules",
    rules: [
      "Participant- Single Participation.",
      "1.In this event, 1 topic will be given on the spot. Topic is related to social issues of the society. Participants have to write one slogan on given topic. (Additional marks will be provided for decoration.)",
      "2.The students should carry colour pens, sketch pens with them if needed.",
      "3.A 30 minutes time will be given for activity.",
      "4.Entries should be in English or Hindi.",
    ],
  },
  ];
export default literary;
